import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { assert } from '@sama/js-core';
import {
  HighlightFeedback,
  highlightFeedbackErrorTypes,
  isHighlightFeedbackErrorType,
} from '../../../../team-apis/otterdam/feedback';
import { FeedbackPanelComponent } from '../../../feedback/views/feedback-panel/feedback-panel.component';
import {
  Feedback,
  UpsertFeedbackComponent,
} from '../../../feedback/views/upsert-feedback/upsert-feedback.component';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';
import { HighlightFeedbackPanelService } from '../../services/highlight-feedback-panel.service';
import { HighlightService } from '../../services/highlight.service';

@Component({
  selector: 'h3-edit-highlight-feedback-panel',
  templateUrl: './edit-highlight-feedback-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FeedbackPanelComponent, UpsertFeedbackComponent],
  host: {
    class: 'mat-elevation-z4 popover-panel',
  },
})
export class EditHighlightFeedbackPanelComponent {
  private readonly store = inject(TaskWorkspaceStore);
  private readonly highlightFeedbackPanelService = inject(
    HighlightFeedbackPanelService,
  );
  private readonly highlightService = inject(HighlightService);

  possibleErrorTags = [...highlightFeedbackErrorTypes];
  selectedHighlight = this.store.state().highlightState.selected;

  getTitle() {
    assert(
      this.selectedHighlight,
      'Selected highlight must be set before editing',
    );
    return `Edit Highlight #${this.selectedHighlight.objectId}`;
  }

  saveHighlight({ errorTag, comment }: Feedback) {
    assert(isHighlightFeedbackErrorType(errorTag), 'invalid errorTag');
    assert(this.selectedHighlight, 'selectedHighlight should be defined');
    const updatedHighlight: HighlightFeedback = {
      ...this.selectedHighlight,
      errorTag,
      comment: comment || undefined,
    };
    this.highlightService.updateHighlight(updatedHighlight);
    this.highlightService.selectHighlight(updatedHighlight);
    this.highlightFeedbackPanelService.showHighlightList('reopen');
  }

  close() {
    this.highlightFeedbackPanelService.close();
  }
}
